import { defineMessages, useIntl } from 'react-intl';

import {
    Button,
    ButtonColor,
    ButtonShape,
    ButtonSize,
    ButtonVariant,
    CloseIcon,
} from '@jsmdg/yoshi';

const messages = defineMessages({
    clearSearch: {
        defaultMessage: 'Löschen',
    },
});

type CloseButtonProps = {
    readonly handleOnClick: () => void;
};

const CloseButton = ({ handleOnClick }: CloseButtonProps): JSX.Element => {
    const intl = useIntl();

    return (
        <Button
            size={ButtonSize.Small}
            variant={ButtonVariant.Ghost}
            color={ButtonColor.Dark}
            shape={ButtonShape.Icon}
            onClick={handleOnClick}
            a11yText={intl.formatMessage(messages.clearSearch)}
        >
            <CloseIcon />
        </Button>
    );
};

export { CloseButton };
